import { Column, Table } from '@tanstack/react-table'
import _ from 'lodash'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import Form from 'react-bootstrap/Form'

export default function TextFilter({
  column,
}: {
  column: Column<any, unknown>
  table: Table<any>
}) {
  const columnFilterValue = column.getFilterValue();

  const [value, setValue] = useState<string>(String(columnFilterValue ?? ''));
  useEffect(() => {
    setValue(String(columnFilterValue ?? ''));
  }, [columnFilterValue]);

  const columnRef = useRef(column);
  columnRef.current = column;

  const debouncedSetFilter = useMemo(
    () =>
      _.debounce((newValue: string) => {
        columnRef.current.setFilterValue(newValue === '' ? undefined : newValue);
      }, 500),
    []
  );

  useEffect(() => () => debouncedSetFilter.cancel(), [debouncedSetFilter]);

  return (
    <Form.Control
      type="text"
      value={value}
      size="sm"
      onChange={(e) => {
        setValue(e.target.value);
        debouncedSetFilter(e.target.value);
      }} />
  );
}
